export default __webpack_public_path__ + "static/media/Img4.f79c46ed.png";